function getBaseConfig(scopeOptions) {
  return {
    name: {
      label: '客户端名称',
      type: 'input',
      value: '',
      props: {
        maxlength: 100,
        'show-word-limit': true,
      },
      rules: {
        required: true,
        trigger: ['change', 'blur'],
        message: '请输入客户端名称',
      },
    },
    scopes: {
      label: '授权范围',
      type: 'select',
      value: [],
      options: scopeOptions,
      props: {
        multiple: true,
        filterable: true,
        placeholder: '请选择授权范围',
      },
      rules: {
        type: 'array',
        required: true,
        trigger: ['change'],
        message: '请选择授权范围',
      },
    },
    description: {
      label: '描述',
      type: 'input',
      value: '',
      props: {
        type: 'textarea',
        rows: 4,
        maxlength: 500,
        'show-word-limit': true,
      },
    },
  };
}

module.exports = ({ type = 'add', scopeOptions = [] } = {}) => {
  const config = getBaseConfig(scopeOptions);

  if (type === 'add') {
    return {
      name: config.name,
      client_id: {
        label: 'Client ID',
        type: 'input',
        value: '',
        props: {
          maxlength: 80,
          'show-word-limit': true,
        },
        rules: {
          required: true,
          trigger: ['change', 'blur'],
          message: '请输入 Client ID',
        },
      },
      scopes: config.scopes,
      description: config.description,
    };
  }

  return {
    name: config.name,
    scopes: config.scopes,
    description: config.description,
    status: {
      label: '状态',
      type: 'radio-group',
      value: 1,
      options: [
        {
          label: '启用',
          value: 1,
        },
        {
          label: '禁用',
          value: 0,
        },
      ],
      rules: {
        required: true,
        trigger: ['change'],
        message: '请选择状态',
      },
    },
  };
};
